import ArticlePage from "@/pages/article/ArticlePage";
import { allArticles } from "@/mocks/articles";

export default function BeginnersArticle() {
  return <ArticlePage article={allArticles["allchinabuy-spreadsheet-beginners"]} />;
}